import React from 'react';
import heart from '../../assets/Icons/heart.svg';
import time from '../../assets/Icons/Clock.svg';
import Time from './Time';
import NuborrowLogo from '../NuborrowLogo/NuborrowLogo';
import StoreBtn from '../StoreButton/StoreButton';
import ListingData from './ListingData';
import { Data } from './Data';
import { Link } from 'gatsby';

const STORE_URLS = {
  iosAppStore: 'https://apps.apple.com/app/nuborrow/id1551821197',
  playStore: 'https://play.google.com/store/apps/details?id=com.fantechlabs.nuborrow'
};

export default function Index() {
  return (
    <footer className=" font-raleway  container">
      <div className="mx-auto px-6 pb-8  lg:px-8">
        {/* upper section */}
        <div className="flex  items-center justify-center gap-2 pt-10 sm:pt-16 md:flex-row md:gap-9">
          <Time
            icon={heart}
            text={'Clients give Nuborrow a 97.6% happiness rating.'}
            heading={'Loved by thousands'}
          />
          <Time
            icon={time}
            text={'Securely apply online in under 30 seconds.'}
            heading={'Apply in seconds'}
          />
        </div>

        <hr className="mx-auto my-8 mb-7 flex h-px items-center justify-center border-0 bg-neutral-800 md:mb-14 md:w-3/5 xl:w-4/6 2xl:w-[1074px]"></hr>

        {/* lower section */}

        <div className="flex flex-col gap-10 lg:flex-row">
          {/* left side */}
          <div className="flex basis-1/4 flex-col items-start justify-around space-y-8 ">
            <NuborrowLogo className="h-5 w-auto md:h-8 lg:h-10" />
            <p className="text-xl font-medium text-neutral-900 ">Download the Nuborrow App</p>
            <div
              className={'mb-16 mt-8 flex flex-col items-center gap-4 sm:flex-row sm:items-stretch'}
            >
              <StoreBtn id="btn_play_store" store={'google'} url={STORE_URLS.playStore} />
              <StoreBtn id="btn_app_store" store={'apple'} url={STORE_URLS.iosAppStore} />
            </div>
            <a
              href="https://www.google.com/maps/search/9131+Keele+St+Unit+A6%2FA7+Vaughan,+ON+L4K0G7/@43.8342475,-79.5094095,17z/data=!3m1!4b1?entry=ttu"
              className="text-sm transition duration-500 "
            >
              Head Office: 9131 Keele St Unit A6/A7 Vaughan, ON L4K0G7
            </a>
            {/* <img src={logo} alt="" className="" /> */}

            <div className="mt-28  hidden items-center justify-start space-x-6 lg:flex ">
              <ul
                role="list"
                className="flex flex-row items-center justify-between gap-3 md:justify-start md:gap-8"
              >
                {Data.legal.map((item) => (
                  <li key={item.name} className="transition duration-500 ">
                    <Link
                      to={item.href}
                      className="text-xs leading-6 text-neutral-900 hover:text-gray-900 md:text-sm "
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* right side listing */}
          <ListingData />
        </div>

        <div className="mt-8 space-x-6 lg:hidden lg:pl-8">
          <ul role="list" className="flex flex-row items-center justify-center gap-8">
            {Data.legal.map((item) => (
              <li key={item.name} className="transition duration-500 ">
                <Link
                  to={item.href}
                  className="text-xs leading-6 text-neutral-900 hover:text-gray-900 md:text-sm"
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="font-roboto pt-8">
          <p className="text-center text-xs leading-5 text-neutral-600">
            Designed by
            <a href="https://www.fantechlabs.io/" className="px-1 text-brand underline">
              Fantech Labs
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
